"use strict";
/**
 * QVET Payables (Vencimientos) Contracts
 * Report ID: 718
 * Payment due dates for supplier invoices (cuentas por pagar)
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.QVET_PAYABLES_SORT_FIELDS = void 0;
/**
 * Query parameters for payables
 */
/** The columns the payables list can be ordered by. The server rejects anything else. */
exports.QVET_PAYABLES_SORT_FIELDS = [
    'supplier',
    'invoiceNumber',
    'supplierInvoice',
    'invoiceDate',
    'dueDate',
    'paymentDate',
    'dueAmount',
];
